function initScroller(root) {
  if (root.dataset.tkCuArrowsInit === '1') return;
  root.dataset.tkCuArrowsInit = '1';

  var list = root.querySelector('.tk-cu__list');
  var prev = root.querySelector('[data-tk-cu-arrow="prev"]');
  var next = root.querySelector('[data-tk-cu-arrow="next"]');
  if (!list || !prev || !next) return;

  function itemStep() {
    var first = list.children[0];
    if (!first) return list.clientWidth;
    var cs = getComputedStyle(list);
    var gap = parseFloat(cs.columnGap || cs.gap || '0') || 0;
    return first.getBoundingClientRect().width + gap;
  }

  function update() {
    var max = list.scrollWidth - list.clientWidth;
    if (max <= 1) { prev.hidden = true; next.hidden = true; return; }
    prev.hidden = list.scrollLeft <= 4;
    next.hidden = list.scrollLeft >= max - 4;
  }

  function go(dir) {
    list.scrollBy({ left: dir * itemStep() * 2, behavior: 'smooth' });
  }

  prev.addEventListener('click', function () { go(-1); });
  next.addEventListener('click', function () { go(1); });
  list.addEventListener('scroll', update, { passive: true });
  if (typeof ResizeObserver !== 'undefined') {
    new ResizeObserver(update).observe(list);
  }
  update();
}

function initAll(scope) {
  var els = (scope || document).querySelectorAll('[data-tk-cu-scroller]');
  for (var i = 0; i < els.length; i++) initScroller(els[i]);
}

if (document.readyState !== 'loading') initAll();
else document.addEventListener('DOMContentLoaded', function () { initAll(); });

new MutationObserver(function (mutations) {
  for (var i = 0; i < mutations.length; i++) {
    var added = mutations[i].addedNodes;
    for (var j = 0; j < added.length; j++) {
      var node = added[j];
      if (node.nodeType !== 1) continue;
      if (node.matches && node.matches('[data-tk-cu-scroller]')) initScroller(node);
      else if (node.querySelector) initAll(node);
    }
  }
}).observe(document.body, { childList: true, subtree: true });
